import { cn } from '@latitude/token-utils';
import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { spinnerVariants } from './variants/root-variants';

export type SpinnerProps = ComponentProps<'div'> &
  VariantProps<typeof spinnerVariants>;

const Spinner = ({ size, variant, className, ...props }: SpinnerProps) => {
  return (
    // Sonar (typescript:S6819) wants <output> instead of role="status" here.
    // Verified empirically that <output> is not a drop-in swap: it hangs
    // @latitude/toggle-group's loading-state screenshot test
    // (vitest-browser/Playwright) on every run, while this div is fine.
    // Root cause not chased down further; div is the one proven safe.
    <div // NOSONAR (typescript:S6819)
      data-testid="spinner"
      role="status"
      aria-busy="true"
      className={cn(
        spinnerVariants({ size, variant }),
        // Must come AFTER the variant's all-sides after:border-color-* class:
        // twMerge treats a later all-sides border-color as overriding earlier
        // per-side colors and would drop these, turning the arc into a full ring.
        'after:border-b-transparent after:border-r-transparent after:border-l-transparent',
        className,
      )}
      {...props}
    />
  );
};

Spinner.displayName = 'Spinner';

export { Spinner };
